import dateFnAdd from 'date-fns/add'
import toDate, { dateParamType } from '~/utils/gcxDates/toDate'

type Result = Date

type Duration = {
  years?: number
  months?: number
  weeks?: number
  days?: number
  hours?: number
  minutes?: number
  seconds?: number
}

const add = (dateProp: dateParamType, duration: Duration) => {
  const date = toDate(dateProp)
  const result: Result = dateFnAdd(date, duration)
  return result
}

export default add
